/**
 * Stills the page under a layer without moving it. The scrollbar goes, and with it the gutter `index.css` keeps for
 * it, or a fixed layer would stop short of the screen's right edge; the page is padded by the room that gave the body.
 * Returns the undo.
 */
export function holdScroll(): () => void {
  const page = document.documentElement;
  const { overflow, paddingRight, scrollbarGutter } = page.style;
  const before = document.body.getBoundingClientRect().width;
  page.style.overflow = "hidden";
  page.style.scrollbarGutter = "auto";
  const grew = document.body.getBoundingClientRect().width - before;
  if (grew > 0) page.style.paddingRight = `${grew}px`;
  return () => {
    page.style.overflow = overflow;
    page.style.paddingRight = paddingRight;
    page.style.scrollbarGutter = scrollbarGutter;
  };
}
